import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refreshMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return false;
    }
  }, []);

  useEffect(() => { refreshMe(); }, [refreshMe]);

  const handle = (data) => {
    localStorage.setItem("fo_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const login = async (email, password) => handle((await api.post("/auth/login", { email, password })).data);
  const register = async (body) => handle((await api.post("/auth/register", body)).data);
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("fo_token");
    setUser(false);
  };

  return <Ctx.Provider value={{ user, login, register, logout, refreshMe }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
